"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

var _base = _interopRequireDefault(require("../../shared/base"));

var _font = _interopRequireDefault(require("../../shared/font"));

var _mediaQueries = _interopRequireDefault(require("../../shared/mediaQueries"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Row = /*#__PURE__*/(0, _reactEmotion.default)('div', {
  target: "e196zbyc0"
})(_base.default, ";", _font.default, ";width:100%;display:flex;flex-direction:row;", (0, _mediaQueries.default)('md'), "{flex-direction:column;}");
var Column = /*#__PURE__*/(0, _reactEmotion.default)('div', {
  target: "e196zbyc1"
})("width:50%;background-color:#193244;text-align:center;padding:6rem 2rem;p{color:#ccc;max-width:450px;margin:16px auto 40px;line-height:1.6rem;}&:last-child{background-color:#021019;}", (0, _mediaQueries.default)('md'), "{width:100%;padding:3rem 2rem;p{max-width:400px;margin:20px auto;}}");

var BannerRow = /*#__PURE__*/function (_Component) {
  function BannerRow() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BannerRow.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutProperties(_this$props, ["children"]);

    return _react.default.createElement(Row, props, children);
  };

  _inheritsLoose(BannerRow, _Component);

  return BannerRow;
}(_react.Component);

exports.default = BannerRow;

_defineProperty(BannerRow, "Column", function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react.default.createElement(Column, props, children);
});

BannerRow.propTypes = {
  children: _propTypes.any // eslint-disable-line

};